import { PageResponse } from '@core/entities/pagination'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { registerItemKeys } from '../registerItemKeys'
import { RequestTypes } from '../requestTypes'
import {
  IRegisterItemAttachment,
  RegisterItemAttachment,
} from '@core/entities/register/RegisterItemAttachment'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = ({
  content,
}: PageResponse<IRegisterItemAttachment>) => {
  return content.map((attachment) => RegisterItemAttachment.new(attachment))
}

export const useGetRegisterItemArchivedAttachments = (
  payload: RequestTypes['getRegisterItemArchivedAttachments'],
  options: UseQueryOptions<
    PageResponse<IRegisterItemAttachment>,
    RequestErrorType,
    Array<RegisterItemAttachment>
  > = {},
) => {
  const archivedAttachmentsQuery = registerItemKeys
    .byId(payload)
    ._ctx.archivedAttachments(payload)

  return useQuery({
    select: dataTransformer,
    ...archivedAttachmentsQuery,
    ...options,
  })
}
